import { cloneElement, useEffect, useState } from "react";
import { AnalyticsService } from "@/services/analytics.js";
import { toast } from "sonner";
import { handleError } from "@/services/errorHandler.js";
import { useNavigate, useParams } from 'react-router-dom'
import * as API from '@/services/api.js'
import { MainLoader } from '@/components/loader/MainLoader.jsx'
import { AUTH_BASE_PATH } from '@/consts/index.js'

export const ExternalAdDataProvider = ({ children }) => {

    const { externalAdId } = useParams()
    const queryParams = new URLSearchParams(window.location.search)
    const spaceId = queryParams.get('spaceId')
    const [adData, setAdData] = useState(null)
    const [advertiser, setAdvertiser] = useState(null)

    const navigate = useNavigate()

    const fetchData = async () => {
        try {
            const { data } = await API.getExternalAdForPublicView(externalAdId, spaceId)
            if (!data) {
                toast.error('Snapshot not found')
                navigate('/')
                return
            }
            setAdData(data.adData)
            setAdvertiser(data.advertiser)
        } catch (e) {
            toast.error(e.message)
            console.log(e)
            handleError(e)
            navigate(AUTH_BASE_PATH)
        }
    }

    useEffect(() => {
        AnalyticsService.page('external-ad-page', { externalAdId })
        if (externalAdId) {
            fetchData()
            return
        }
        navigate('/')
    }, []);

    return (
        (!adData || !advertiser) ? <MainLoader className="absolute w-full h-full z-10 bg-hero-background" /> : cloneElement(children, { adData, advertiser })
    )

}
